import { VariableBase } from '../../interfaces/variables/variable-base';

export class Variable implements VariableBase {
	devValue = '';
	testValue = '';
	prodValue = '';

	constructor(init?: Partial<Variable>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
